import { types } from "../types";
const initialState = {
  colleges: [],
  collegeToUpdate: null,
  collegeToDelete: null,
  collegeName: null,
  collegeInfo: null,
};

export const collegeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getCollege:
      return {
        ...state,
        colleges: action.payload,
      };
    case types.createCollege:
      return {
        ...state,
        colleges: [action.payload, ...state.colleges],
      };

    case types.updateCollege:
      return {
        ...state,
        colleges: state.colleges.map((college) =>
          college._id === action.payload._id ? action.payload : college
        ),
      };

    case types.deleteCollege:
      return {
        ...state,
        colleges: state.colleges.filter(
          (college) => college._id !== action.payload
        ),
      };

    case types.setCollegeToUpdate:
      return {
        ...state,
        collegeToUpdate: action.payload,
      };

    case types.removeCollegeFromUpdate:
      return {
        ...state,
        collegeToUpdate: null,
      };

    case types.setCollegeToDelete:
      return {
        ...state,
        collegeToDelete: action.payload,
        collegeName: state.colleges.filter((college) =>
          college._id === action.payload ? college : null
        ),
      };

    case types.removeCollegeFromDelete:
      return {
        ...state,
        collegeToDelete: null,
        collegeName: null,
      };

    case types.setCollegeInformation:
      return {
        ...state,
        collegeInfo: action.payload,
      };

    case types.removeCollegeInformation:
      return {
        ...state,
        collegeInfo: null,
      };

    default:
      return state;
  }
};
